import { render, staticRenderFns } from "./Act.vue?vue&type=template&id=b4adcf5a&scoped=true&lang=pug&"
import script from "./Act.vue?vue&type=script&lang=js&"
export * from "./Act.vue?vue&type=script&lang=js&"
import style0 from "./Act.vue?vue&type=style&index=0&id=b4adcf5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4adcf5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCard,VCardTitle,VContainer,VDialog,VIcon,VProgressCircular})
